import { render } from "./share.vue?vue&type=template&id=459ae0d3&scoped=true"
import script from "./share.vue?vue&type=script&lang=js"
export * from "./share.vue?vue&type=script&lang=js"

import "./share.vue?vue&type=style&index=0&id=459ae0d3&lang=scss&scoped=true"

import exportComponent from "/var/www/birchplace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-459ae0d3"]])

export default __exports__